module.exports = __webpack_public_path__ + "static/media/datatable.00c17d58.png";